export const START_INITIAL_LOADING = 'START_INITIAL_LOADING';
export const END_INITIAL_LOADING = 'END_INITIAL_LOADING';
export const START_CONTENT_LOADING = 'CONTENT_LOADING';
export const END_CONTENT_LOADING = 'END_CONTENT_LOADING';
export const START_BUTTON_LOADING = 'START_BUTTON_LOADING';
export const END_BUTTON_LOADING = 'END_BUTTON_LOADING';

export function startInitialLoading() {
    return {
        type: START_INITIAL_LOADING
    }
}

export function endInitialLoading() {
    return {
        type: END_INITIAL_LOADING
    }
}

export function startContentLoading() {
    return {
        type: START_CONTENT_LOADING
    }
}

export function endContentLoading() {
    return {
        type: END_CONTENT_LOADING
    }
}

export function startButtonLoading() {
    return {
        type: START_BUTTON_LOADING
    }
}

export function endButtonLoading() {
    return {
        type: END_BUTTON_LOADING
    }
}